import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';

import {reset} from "../../../../actions/reset";
/*** components ***/
import {MainOption} from '../../../../components/buildcomponent/Options/MainOption';
import {additionalOptionsList} from "./OptionsList";

/*** helpers ***/
import { mainOptionsList } from './OptionsList';

/*** styles ***/
import './style.css';

class OptionArea extends Component{
    showErrorOrNextStep = (e) => {
        const isNextStep = !(+this.props.buildValues.length % 5) && !(+this.props.buildValues.width % 5);
        if(!isNextStep){
            e.preventDefault();
            NotificationManager.error("Bitte die Masse in 5cm Abständen eingeben.");
        }
    };

    reset = () => {
      this.props.reset();
    }

  render(){
      const urlParams = this.props.match.url.split("/"),
            currentStep = urlParams[urlParams.length - 1],
            nextStep = +urlParams[urlParams.length - 1] + 1;
      const isNextStep = !(+this.props.buildValues.length % 5) && !(+this.props.buildValues.width % 5);
    return(
        <div className="option-area-step-1">
            <div className="main-options-step-1">
                <h2 className={"main-options-header-step-1"}>DIMENSIONEN (Zentimeter)</h2>
                <ul className={"main-options-options-step-1"}>
                    {mainOptionsList.map((item, index) =>{
                       return ( <MainOption
                            key = {item.optionName}
                            optionName = {item.optionName}
                            index = {index}
                            step = {5}

                            type = {item.type}
                            value = {this.props.buildValues[item.dataInputName]}
                            changeInputValue = {this.props.changeInputValue}
                            dataInputName = {item.dataInputName}
                        />);
                    }
                    )}
                </ul>
            </div>
            <div className="additional-options-step-1">
                <ul className="additional-options-options-step-1">
                    <li className="additional-option-option-step-1">
                        <label htmlFor="" className="additional-options-option-name-step-1">Inklusiv Deckel</label>
                        <div className="wrapper-additional-option-value-step-1">
                            <input
                                type="checkbox"
                                className={"additional-options-checkbox-step-1"}
                                data-input-name = {"deckel"}
                                onChange={this.props.changeInputValue}
                                checked = {this.props.buildValues.deckel}
                            />
                        </div>
                    </li>
                    {this.props.buildValues.deckel ?
                        <li className="additional-option-option-step-1">
                            <label htmlFor="" className="additional-options-option-name-step-1">Deckelklasse</label>
                            <div className="wrapper-additional-option-value-step-1">
                                <select
                                    name="deckelklasse"
                                    data-input-name = {"deckelklasse"}
                                    value = {this.props.buildValues.deckelklasse}
                                    onChange={this.props.changeInputValue}
                                    className={"additional-options-select-step-1"}
                                >
                                    {additionalOptionsList.map((item) =>
                                        <option key ={item} value={item}>{item}</option>
                                    )}
                                </select>
                            </div>
                        </li> :
                        null
                    }

                    <li className="additional-option-option-step-1">
                        <label htmlFor="" className="additional-options-option-name-step-1">Inklusiv Boden</label>
                        <div className="wrapper-additional-option-value-step-1">
                            <input
                                type="checkbox"
                                className={"additional-options-checkbox-step-1"}
                                data-input-name = {"boden"}
                                onChange={this.props.changeInputValue}
                                checked = {this.props.buildValues.boden}
                            />
                        </div>
                    </li>
                </ul>
                <div className="button-next-step-step-1">
                     <Link to={`/step/${currentStep}`}>
                        <button
                            className={`button-next-step-step-1-reset ${isNextStep ? null : "disable-next-step-1"}`}
                            // disabled={!isNextStep}
                            onClick = {this.reset}
                        >
                            RESET
                        </button>
                    </Link>
                    <Link to={`/step/${nextStep}`}>
                        <button
                            className={`button-next-step-step-1-next ${isNextStep ? null : "disable-next-step-1"}`}
                            // disabled={!isNextStep}
                            onClick = {this.showErrorOrNextStep}
                        >
                            WEITER ZUR ANSICHT A >>
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
        buildValues : state.buildValues
    };
};

const mapStateToDispatch = {
  reset
};

export default withRouter(connect(mapStateToProps, mapStateToDispatch)(OptionArea))


// WEBPACK FOOTER //
// ./src/containers/steps/step1/OptionArea/index.js